import React__default from 'react';
import { ComboboxInput } from './combobox-input.component.js';
import { useSwanComboboxContext } from './combobox.context.js';
import { searchInputPropTypes, SearchInput } from '../search-input/search-input.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * @subcomponent Combobox
 */ const ComboboxSearchInput = renderWithRef('ComboboxSearchInput', searchInputPropTypes, (props, ref)=>{
    const { triggerRef, setInputValue } = useSwanComboboxContext();
    const getSearchInputProps = (p)=>{
        return _object_spread_props(_object_spread({}, p), {
            onClear: (e)=>{
                var _props_onClear;
                (_props_onClear = props.onClear) === null || _props_onClear === void 0 ? void 0 : _props_onClear.call(props, e);
                setInputValue('');
            }
        });
    };
    return /*#__PURE__*/ React__default.createElement(RenderComp, {
        root: "div",
        forwardedRef: triggerRef,
        classNames: [
            'swan-combobox-search-input-container'
        ],
        props: {}
    }, /*#__PURE__*/ React__default.createElement(ComboboxInput, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        render: (p, r)=>/*#__PURE__*/ React__default.createElement(RenderComp, {
                root: SearchInput,
                forwardedRef: r,
                props: getSearchInputProps(p)
            })
    })));
});

export { ComboboxSearchInput };
